import React, { useState } from 'react'
import Navbar from '../../components/navbar/navbar'
import apinode from '../../services/apinode'
import { useOrdenation } from '../../hooks/useOrdenation'
import pdfMake from 'pdfmake/build/pdfmake'
import './relatorio-produtos-vendidos.css'
import { formatDate } from '../../utils/formatDate'
import { CustomButton } from '../../components/CustomButton'
import { InfoCircleFill, XCircleFill } from 'react-bootstrap-icons'
import { sendErrorApiMessage } from '../../utils/sendErrorApiMessage'

export function RelatorioProdutosVendidos() {
  const conta = localStorage.idconta

  const [filtros, setFiltros] = useState({
    dataInicial: '',
    dataFinal: '',
    sku: '',
    descricao: '',
    quantity: 20,
  })

  const [produtos, setProdutos] = useState([])
  const [loading, setLoading] = useState(false)
  const [erro, setErro] = useState('')
  const [buscou, setBuscou] = useState(false)
  const [info, setInfo] = useState({})

  const { filteredItems, Th, Paginate, itemsPerPage, setItemsPerPage, page } =
    useOrdenation(produtos, 'total_pedidos', 'desc')

  async function handleGetInfo(sku, index) {
    try {
      setInfo((prev) => ({
        [index]: {
          ...prev[index],
          loading: true,
        },
      }))

      const params = new URLSearchParams()

      params.set('dataInicial', filtros.dataInicial)
      params.set('dataFinal', filtros.dataFinal)
      params.set('sku', sku)

      const response = await apinode.get(
        `/relatorio/produtos-vendidos/info/${conta}?${params.toString()}`,
      )

      setInfo((prev) => ({
        [index]: {
          ...prev[index],
          data: response.data,
          open: true,
        },
      }))
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao buscar informações')
    } finally {
      setInfo((prev) => ({
        [index]: {
          ...prev[index],
          loading: false,
        },
      }))
    }
  }

  function handleGerarRelatorio() {
    if (produtos.length === 0) return

    const linhasTabela = produtos.map((produto, index) => [
      { text: String(index + 1), alignment: 'center' },
      produto.sku ?? '',
      produto.descricao ?? '',
      {
        text: String(produto.total_pedidos ?? 0),
        alignment: 'center',
        bold: true,
      },
    ])

    const docDefinition = {
      pageMargins: [40, 60, 40, 50],
      header: {
        text: 'Relatório de Produtos Mais Vendidos',
        alignment: 'center',
        margin: [0, 20, 0, 0],
        fontSize: 10,
        color: '#9ca3af',
      },
      footer: (currentPage, pageCount) => ({
        text: `Página ${currentPage} de ${pageCount}`,
        alignment: 'center',
        fontSize: 9,
        color: '#9ca3af',
        margin: [0, 10, 0, 0],
      }),
      content: [
        {
          text: 'Produtos Mais Vendidos',
          fontSize: 20,
          bold: true,
          color: '#1a1a1a',
          margin: [0, 0, 0, 4],
        },
        {
          text: `Período: ${formatDate(filtros.dataInicial)} a ${formatDate(filtros.dataFinal)}`,
          fontSize: 11,
          color: '#6b7280',
          margin: [0, 0, 0, 2],
        },
        ...(filtros.sku
          ? [{ text: `SKU: ${filtros.sku}`, fontSize: 11, color: '#6b7280' }]
          : []),
        ...(filtros.descricao
          ? [
              {
                text: `Descrição: ${filtros.descricao}`,
                fontSize: 11,
                color: '#6b7280',
              },
            ]
          : []),
        { text: ' ', margin: [0, 8, 0, 0] },
        {
          table: {
            headerRows: 1,
            widths: [30, 90, '*', 90],
            body: [
              [
                { text: '#', style: 'tableHeader', alignment: 'center' },
                { text: 'SKU', style: 'tableHeader' },
                { text: 'Descrição', style: 'tableHeader' },
                {
                  text: 'Total de Pedidos',
                  style: 'tableHeader',
                  alignment: 'center',
                },
              ],
              ...linhasTabela,
            ],
          },
          layout: {
            fillColor: (rowIndex) =>
              rowIndex === 0
                ? '#4f46e5'
                : rowIndex % 2 === 0
                  ? '#f9fafb'
                  : null,
            hLineWidth: () => 0.5,
            vLineWidth: () => 0,
            hLineColor: () => '#e5e7eb',
            paddingTop: () => 8,
            paddingBottom: () => 8,
          },
        },
        {
          text: `Total de produtos no ranking: ${produtos.length}`,
          fontSize: 10,
          color: '#6b7280',
          margin: [0, 16, 0, 0],
        },
      ],
      styles: {
        tableHeader: {
          bold: true,
          color: '#ffffff',
          fontSize: 11,
        },
      },
      defaultStyle: {
        fontSize: 10,
        color: '#1a1a1a',
      },
    }

    const dataGeracao = new Date().toISOString().slice(0, 10)

    pdfMake
      .createPdf(docDefinition)
      .download(`produtos-mais-vendidos-${dataGeracao}.pdf`)
  }

  function handleChange(e) {
    const { name, value } = e.target
    setFiltros((prev) => ({ ...prev, [name]: value }))
  }

  async function handleBuscar(e) {
    e.preventDefault()

    if (!filtros.dataInicial || !filtros.dataFinal) {
      setErro('Informe a data inicial e a data final.')
      return
    }

    setErro('')
    setLoading(true)
    setBuscou(true)

    try {
      const params = new URLSearchParams()
      params.set('quantity', filtros.quantity || 20)
      params.set('dataInicial', filtros.dataInicial)
      params.set('dataFinal', filtros.dataFinal)
      if (filtros.sku) params.set('sku', filtros.sku)
      if (filtros.descricao) params.set('descricao', filtros.descricao)

      const response = await apinode.get(
        `/relatorio/produtos-vendidos/${conta}?${params.toString()}`,
      )

      setProdutos(response.data)
    } catch (err) {
      setErro(err.message || 'Erro inesperado ao buscar o relatório.')
      setProdutos([])
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <Navbar />

      <div className="rpv-container">
        <header className="rpv-header">
          <h1>Produtos mais vendidos</h1>
          <p>Ranking de produtos por quantidade de pedidos no período</p>
        </header>

        <form
          className="rpv-filtros"
          onSubmit={handleBuscar}
        >
          <div className="rpv-campo">
            <label htmlFor="dataInicial">Data inicial</label>
            <input
              id="dataInicial"
              type="date"
              name="dataInicial"
              value={filtros.dataInicial}
              onChange={handleChange}
            />
          </div>

          <div className="rpv-campo">
            <label htmlFor="dataFinal">Data final</label>
            <input
              id="dataFinal"
              type="date"
              name="dataFinal"
              value={filtros.dataFinal}
              onChange={handleChange}
            />
          </div>

          <div className="rpv-campo">
            <label htmlFor="sku">SKU</label>
            <input
              id="sku"
              type="text"
              name="sku"
              placeholder="Ex: ABC123"
              value={filtros.sku}
              onChange={handleChange}
            />
          </div>

          <div className="rpv-campo rpv-campo-descricao">
            <label htmlFor="descricao">Descrição</label>
            <input
              id="descricao"
              type="text"
              name="descricao"
              placeholder="Buscar por nome do produto"
              value={filtros.descricao}
              onChange={handleChange}
            />
          </div>

          <div className="rpv-campo rpv-campo-qtd">
            <label htmlFor="quantity">Top</label>
            <input
              id="quantity"
              type="number"
              name="quantity"
              min="1"
              value={filtros.quantity}
              onChange={handleChange}
            />
          </div>

          <div className="rpv-campo rpv-campo-qtd">
            <label htmlFor="per_page">Paginação</label>
            <select
              id="per_page"
              name="per_page"
              value={itemsPerPage}
              onChange={(e) => setItemsPerPage(e.target.value)}
            >
              <option value={'10'}>10</option>
              <option value={'20'}>20</option>
              <option value={'50'}>50</option>
              <option value={'100'}>100</option>
            </select>
          </div>

          <button
            type="submit"
            className="rpv-btn"
            disabled={loading}
          >
            {loading ? 'Buscando...' : 'Buscar'}
          </button>

          <button
            className="rpv-btn"
            onClick={handleGerarRelatorio}
          >
            {' '}
            Gerar Relatório{' '}
          </button>
        </form>

        {erro && <div className="rpv-erro">{erro}</div>}

        <div className="rpv-resultado">
          {loading && <div className="rpv-loading">Carregando produtos...</div>}

          {!loading && buscou && produtos.length === 0 && !erro && (
            <div className="rpv-vazio">
              Nenhum produto encontrado para os filtros informados.
            </div>
          )}

          {!loading && filteredItems.length > 0 && (
            <table className="rpv-tabela">
              <thead>
                <tr>
                  <th>#</th>
                  <Th
                    label="SKU"
                    value="sku"
                  />

                  <Th
                    label="Descrição"
                    value="descricao"
                  />

                  <Th label="Tipo" />

                  <Th
                    label="Total de pedidos"
                    value="total_pedidos"
                  />

                  <th>Ação</th>
                </tr>
              </thead>
              <tbody>
                {filteredItems.map((produto, index) => (
                  <React.Fragment key={produto.sku}>
                    <tr>
                      <td>
                        {page === 0
                          ? index + 1
                          : page * itemsPerPage + (index + 1)}
                      </td>
                      <td>{produto.sku}</td>
                      <td>{produto.descricao}</td>
                      <td>
                        <span
                          className={`rpv-badge ${
                            produto.sku_principal
                              ? 'rpv-badge-filho'
                              : 'rpv-badge-pai'
                          }`}
                        >
                          {produto.pai ? 'Filho' : 'Pai / Único'}
                        </span>
                      </td>
                      <td className="rpv-total">{produto.total_pedidos}</td>
                      <td>
                        <CustomButton
                          isLoading={info[index]?.loading}
                          onClick={() => {
                            if (info[index]?.open) {
                              setInfo({})
                            } else {
                              handleGetInfo(produto.sku, index)
                            }
                          }}
                        >
                          {info[index]?.open ? (
                            <XCircleFill size={15} />
                          ) : (
                            <InfoCircleFill size={15} />
                          )}
                        </CustomButton>
                      </td>
                    </tr>

                    {info[index]?.open && (
                      <tr className="rpv-info-row">
                        <td colSpan={6}>
                          <div className="rpv-info-painel">
                            <div className="rpv-info-secao">
                              <h4>Vendas por conta</h4>

                              {info[index].data.accountsGroup?.length > 0 ? (
                                <table className="rpv-subtabela">
                                  <thead>
                                    <tr>
                                      <th>Conta</th>
                                      <th>Total de pedidos</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {info[index].data.accountsGroup.map(
                                      (conta) => (
                                        <tr key={conta.apelido}>
                                          <td>{conta.apelido}</td>
                                          <td className="rpv-total">
                                            {conta.total_pedidos}
                                          </td>
                                        </tr>
                                      ),
                                    )}
                                  </tbody>
                                </table>
                              ) : (
                                <p className="rpv-info-vazio">
                                  Nenhuma venda encontrada no período.
                                </p>
                              )}
                            </div>

                            {info[index].data.salesChild ? (
                              <div className="rpv-info-secao">
                                <h4>Vendas por produto filho</h4>

                                {info[index].data.salesChild.length > 0 ? (
                                  <table className="rpv-subtabela">
                                    <thead>
                                      <tr>
                                        <th>SKU</th>
                                        <th>Descrição</th>
                                        <th>Total de pedidos</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {info[index].data.salesChild.map(
                                        (filho) => (
                                          <tr key={filho.sku}>
                                            <td>{filho.sku}</td>
                                            <td>{filho.descricao}</td>
                                            <td className="rpv-total">
                                              {filho.total_pedidos}
                                            </td>
                                          </tr>
                                        ),
                                      )}
                                    </tbody>
                                  </table>
                                ) : (
                                  <p className="rpv-info-vazio">
                                    Nenhum produto filho vendido no período.
                                  </p>
                                )}
                              </div>
                            ) : (
                              <div className="rpv-info-secao">
                                <p className="rpv-info-vazio">
                                  Este é um produto filho OU não possui produtos
                                  derivados.
                                </p>
                              </div>
                            )}
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          )}
        </div>

        <Paginate />
      </div>
    </>
  )
}
